import { render, staticRenderFns } from "./ImageElement.vue?vue&type=template&id=07950f3a&scoped=true&"
import script from "./ImageElement.vue?vue&type=script&lang=js&"
export * from "./ImageElement.vue?vue&type=script&lang=js&"
import style0 from "./ImageElement.vue?vue&type=style&index=0&id=07950f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07950f3a",
  null
  
)

export default component.exports